import React from "react";

const FavoriteToggleButton = ({ active = false, label = "게임", onToggle }) => (
  <button
    type="button"
    className={`favorite-toggle${active ? " is-active" : ""}`}
    aria-pressed={active}
    aria-label={`${label} 즐겨찾기 ${active ? "해제" : "추가"}`}
    onClick={(event) => {
      event.preventDefault();
      event.stopPropagation();
      onToggle?.();
    }}
  >
    <span aria-hidden="true">{active ? "★" : "☆"}</span>
  </button>
);

export default FavoriteToggleButton;
